export default __webpack_public_path__ + "static/media/vi.d.ts.5510ed97.map";